export default "__VITE_ASSET__e67a48bd__"